<ul class="pagination justify-content-center mt-md-6">
  <li class="pagination__item">
    <button
      class="pagination__item__link button button-icon button-icon--secondary"
      [routerLink]="[]"
      [disabled]="page().current === 0"
      [class.is--disabled]="page().current === 0"
      [queryParams]="{ page: page().current - 1 }"
    >
      <span class="sr-only">Vorige Pagina</span>
      <fstr-icon class="icon-secondary icon-xs" [anchor]="'icon-arrow-left'"></fstr-icon>
    </button>
  </li>
  <li class="pagination__item d-md-none d-flex align-items-center pr-2 pl-2">{{ page().current + 1 }} / {{ pages().length + 1 }}</li>
  @for (p of pages(); track p) {
    <li class="pagination__item d-none d-md-flex">
      <button
        class="pagination__item__link button button-icon button-icon--muted-light"
        [routerLink]="[]"
        [queryParams]="{ page: p }"
        [routerLinkActive]="'is--active'"
        [class.is--active]="page().current === 0 && p === 0"
      >
        <span class="sr-only">Pagina</span>
        <span>{{ p + 1 }}</span>
      </button>
    </li>
  }
  @if (page().pageCount > 0) {
    <li class="pagination__item">
      <button
        class="pagination__item__link button button-icon button-icon--secondary"
        [routerLink]="[]"
        [queryParams]="{ page: page().current + 1 }"
        [disabled]="!(page().current < page().pageCount)"
      >
        <span class="sr-only">Volgende Pagina</span>
        <fstr-icon class="icon-secondary icon-xs" [anchor]="'icon-arrow-right'"></fstr-icon>
      </button>
    </li>
  }
</ul>
